import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RouteName } from '@mews-commander/enums';
import { AccountBillingContainer } from '@mews-commander/modules/src/modules/billing';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => <AccountBillingContainer accountId={Route.useParams().accountId} />;

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Billing/Account/$accountId')({
    validateSearch: z.object({
        billId: z.string().uuid().optional(),
        EnterpriseId: z.string().uuid().optional(),
    }),
    beforeLoad: ({ context: { checkPrivilege } }) => {
        checkPrivilege('manageAccounts');
    },
    component: Component,
    staticData: {
        routeName: RouteName.BillingAccount,
        owner: MewsTeam.Billing,
        type: RouteType.Frontend,
    },
});
